import React from 'react';
import clsx from "clsx";
import CatchErrors from "../../../../Utility/CatchErrors";
import ItemClusterMain from "./ItemClusterMain";
import AddToolProduct from "../../StandardItems/AddToolProduct";
import ItemClusterSelectorsList from "../../StandardItems/ItemClusterSelectorsList";
import ItemClusterImages from "../image_display/ItemClusterImages";
import ToolProductInfo from "../../StandardItems/ToolProductInfo";
import AddToCartWithQuantity from "../../StandardItems/AddToCartWithQuantity";
import ToolPriceDisplay from "./ToolPriceDisplay";
import {camelizeKeysDeep} from "../../../../ReduxStore/Helpers/transformObject";

export default function ToolItemClusterUi({
  cluster, clusterState, products, clusterCount = 1,
  itemCache, cartItem, sectionConfig, shoppingCart
}) {

  const className = clsx('my-4 border-gray-200 pb-2 border-b');
  const {selectedItem} = clusterState;

  const product = camelizeKeysDeep(selectedItem?.product);

  // cluster.id like front_row_neosupreme_seat_covers
  return <div className={className} id={"item-cluster-" + cluster.id}>
    <h3 className="font-bold text-sm py-2">{cluster.headline}</h3>
    <CatchErrors>
      <div className="border-gray-200 pb-2 border-b"><ItemClusterSelectorsList
        itemCache={itemCache}
        cluster={cluster}
        clusterState={clusterState}
      />
      </div>
    </CatchErrors>

    <div className="grid grid-cols-3 gap-1">
      <div className="col-span-2">
        <CatchErrors><ToolProductInfo product={product}/></CatchErrors>
      </div>
      <div className="pt-2">
        <CatchErrors><ItemClusterImages
          product={product}
          products={products}
          itemCache={itemCache}
          cluster={cluster}
          clusterState={clusterState}
          showZoom={true}
        /></CatchErrors>
      </div>

    </div>

    <div className="grid grid-cols-3 my-2">
      <div className="col-span-2">
        <CatchErrors><AddToCartWithQuantity product={product} cartItem={cartItem}
          shoppingCart={shoppingCart}/>
        </CatchErrors>
      </div>
      <div>
        <CatchErrors><ToolPriceDisplay product={product}/></CatchErrors>
      </div>
    </div>
  </div>
}
